"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Routes = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_router_dom_1 = require("react-router-dom");
const BaseRoutes_1 = require("./BaseRoutes");
const initializer_1 = require("../initializer");
function Routes(props) {
    const onLogin = (data) => {
        location.replace(props.mainRouteToRedirect);
    };
    return ((0, jsx_runtime_1.jsx)(BaseRoutes_1.BaseRoutes, { ...props, children: props.componentFakeLogin && ((0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { exact: true, path: "/login", component: () => ((0, jsx_runtime_1.jsx)(props.componentFakeLogin, { doLogin: initializer_1.Authenticator.login, doPasswordPosition: initializer_1.Authenticator.getPasswordPositions, onLogin: onLogin })) }, "login")) }));
}
exports.Routes = Routes;
//# sourceMappingURL=Routes.js.map